<template>
    <div class="steps" v-if='activeStep !== "finished"'
        :class="{ 'px30': $store.state.loginActiveStep !== 'finished' }">
        <div class="step-item" :class="{ 'active-step': activeStep === 'cause' }">
            <Icons :icon="!$store.state.loginSteps.cause ? 'heart' : 'check'"></Icons>
            <span class="step-title">{{ $t("Choose Cause") }}</span>
        </div>
        <div class="step-item" :class="{
            'active-step': ['card', 'bank', 'addCard', 'provide'].indexOf(activeStep) !== -1,
        }">
            <Icons :icon="!$store.state.loginSteps.card ? 'card' : 'check'"></Icons>
            <span class="step-title">{{ $t("Link Account") }}</span>
        </div>
        <div class="step-item" :class="{
            'active-step': ['donation'].indexOf(activeStep) !== -1,
        }">
            <Icons :icon="!$store.state.loginSteps.donation ? 'user' : 'check'"></Icons>
            <span class="step-title">{{ $t("Fund Donation") }}</span>
        </div>
        <div class="step-item" :class="{ 'active-step': activeStep === 'finished' }">
            <Icons icon="star"></Icons>
            <span class="step-title">{{ $t("Finish") }}</span>
        </div>
    </div>
</template>

<script>
import Icons from "../Icons/Icons";

export default {
    name: "Steps",

    props: ["activeStep"],

    components: {
        Icons,
    },

    mounted() {
        this.$setState('step_header', true);
    },

    data: function () {
        return {};
    },
};
</script>
